// LOCALHOST SETTINGS
// const API_BASE_URL = 'http://localhost:5000';
// export default API_BASE_URL;

// PRODUCTION SETTINGS
// const API_BASE_URL = 'https://api.dlc-auto-finance.ro';
const API_BASE_URL = "https://api.dlc-auto-finance.ro";
export default API_BASE_URL;
